import styled from 'styled-components';

export const StyledChartDashboard = styled.div`
  display: flex;
  color: var(--color-text-main);

  h2 {
    font-size: 16px;
    font-weight: 600;
  }

  .cd-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
  }

  .time-pjt-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    order: 0;
  }

  @media (min-width: 1920px) {
    .cd-wrapper {
      &.true {
        max-width: 1740px;
        width: 100%;

        > div {
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(6) {
            min-width: 565px;
            width: 565px;

            > div {
              width: 100%;
              min-width: 100%;

              > div {
                width: 100%;
                min-width: 100%;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 1919px) {
    .cd-wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      .time-pjt-wrapper {
        order: -1;
      }

      > div {
        width: 100%;

        > div {
          width: 100%;

          > div {
            width: 100%;
          }
        }
      }
    }
  }

  @media (max-width: 1023px) {
    .cd-wrapper {
      display: flex;
    }
  }
`;
